import { Flex } from "antd"
import TreeContainer from "./TreeContainer.jsx"
import SummaryDetails from "./SummaryDetails.jsx"


const EstimationSummary = () => {


    return (
        <div className="page-wrapper">
            <Flex gap={40} style={{width: "100%"}}>
                <TreeContainer />
                <SummaryDetails />
            </Flex>
        </div>
    )
}

export default EstimationSummary